const WebOSTvKey = {
  N1: 49,
  N2: 50,
  N3: 51,
  N4: 52,
  N5: 53,
  N6: 54,
  N7: 55,
  N8: 56,
  N9: 57,
  N0: 48,
  PRECH: 10190,
  VOL_UP: 448,
  VOL_DOWN: 447,
  MUTE: 449,
  CH_UP: 427,
  CH_DOWN: 428,
  TOOLS: 10135,
  ENTER: 13,
  BACK: 461,
  RETURN: 461,
  INFO: 457,
  EXIT: 1001,
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  RED: 403,
  GREEN: 404,
  YELLOW: 405,
  BLUE: 406,
  RW: 412,
  PAUSE: 19,
  FF: 417,
  REC: 416,
  PLAY: 415,
  STOP: 413,
  PLAYPAUSE: 10252,
};

export default WebOSTvKey;
